import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 6h2v14H6V6h2V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2zm2 0h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2zM6 6v14H4a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2zm4-1v1h4V5z"
    }, null, -1)
  ])))
}
export default { render: render }